import React from 'react'

interface NotificationBodyProps {
  children: React.ReactNode
}

const NotificationBody = ({ children }: NotificationBodyProps) => <div>{children}</div>

export default NotificationBody
